<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Header({
              text: 'Aktywności',
              type: 'h4'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => ({
                headerLabel: `Aktywność nr ${i + 1}`,
                fields: [
                  new fields.Input({
                    label: 'Header',
                    modelPath: [this, 'form', 'items', i, 'header'],
                    required: false,
                    multilingual: true
                  }),
                  new fields.Image({
                    label: 'Grafika',
                    required: true,
                    modelPath: [this, 'form', 'items', i, 'image'],
                    multilingual: true
                  }),
                  new fields.Link({
                    label: 'Link',
                    required: true,
                    modelPath: [this, 'form', 'items', i, 'link']
                  }),
                  new fields.Input({
                    label: 'Lead',
                    type: 'textarea',
                    modelPath: [this, 'form', 'items', i, 'text'],
                    required: true,
                    multilingual: true
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
